import { initHighcharts } from '~/config/highcharts';
import { initializeSocketClient } from '~/clients/subscriptions';
import './extendNative.js';

// [HIGHCHARTS-10-MIGRATION-TAG]: Find and delete/clean all places like this once the migration ends
export function initGlobalDependencies({ highchartsVersion } = {}) {
  initHighcharts({ version: highchartsVersion });
  initializeSocketClient();
}
